module.exports = __webpack_public_path__ + "static/media/ImgWord.58ddb844.svg";